import api from '../../api-request'
// 获取企业配置信息
function getMessage(){
  return api.get('/traffic/wx/config/info')
}
//  修改企业配置信息
function updateMessage(params) {
  return api.post('/traffic/common/config/edit', params)
}
// 获取用户角色列表
function getUserRoleList() {
  return api.get('/traffic/user/permission/list')
}
// 设置角色权限
function setUserRolePer(params) {
  return api.post('/traffic/user/permission/choose', params)
}
// 获取角色数据权限
function changeRolePermission(params) {
  return api.post('/traffic/user/data/choose', params)
}
// 获取不同角色下的用户List
function getUserInfoList(params) {
  return api.get('/traffic/owner/user/list', {params});
}
// 用户修改角色
function changeUserRole(params) {
  return api.post('/traffic/user/permission/add', params);
}

export default {
  getMessage ,
  updateMessage,
  getUserRoleList,
  setUserRolePer,
  changeRolePermission,
  getUserInfoList,
  changeUserRole,
}
